var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOut2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(-384 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 60,
    height: 60,
    rx: 30,
    transform: "translate(384 216)",
    fill: "#f3f8fe",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610",
    transform: "translate(-1427.428 1191.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M1842.573-958.153q-.1.882-.2,1.765a2.6,2.6,0,0,0-.044.473c.021.287-.111.323-.367.334a22.343,22.343,0,0,0-2.592.192,9.582,9.582,0,0,0-4.657,2.193,10.129,10.129,0,0,0-3.488,5.762,9.911,9.911,0,0,0,.715,6.381,10.157,10.157,0,0,0,4.391,4.728,9.907,9.907,0,0,0,5.589,1.256,10.06,10.06,0,0,0,6.563-2.968,9.907,9.907,0,0,0,2.961-5.991c.085-.7.069-1.417.1-2.125,0-.1,0-.2,0-.315l2.428-.258c.048.212.092.411.136.61v1.555c-.015.089-.033.178-.046.267-.076.537-.118,1.081-.232,1.609a12.577,12.577,0,0,1-4.26,7.135,12.513,12.513,0,0,1-9.6,3.005,12.252,12.252,0,0,1-6.75-2.793,12.628,12.628,0,0,1-4.775-9.4,11.925,11.925,0,0,1,1.246-6.092,12.7,12.7,0,0,1,9.389-7.124c.473-.091.956-.133,1.435-.2Z",
    transform: "translate(0 0)",
    fill: "#fe022c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M2103.19-950.429l-2.2-.017h-.349v-3.27l-4.579,4.584-1.856-1.856,4.6-4.591h-3.335v-2.573h7.724Z",
    transform: "translate(-249.082 0)",
    fill: "#fe022c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M2014.877-870.108h3.827v2.574h-.274c-1.946,0-3.893,0-5.839.005-.228,0-.294-.058-.293-.291q.012-4.21,0-8.42c0-.229.058-.3.291-.293.677.016,1.354.014,2.03,0,.214,0,.263.068.262.271-.007,1.938,0,3.876,0,5.814Z",
    transform: "translate(-172.321 -76.493)",
    fill: "#fe022c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut2);
export default __webpack_public_path__ + "static/media/checkOut2.9530df0adff0a280d909d239241f83b0.svg";
export { ForwardRef as ReactComponent };